<template>
	<TopBar>
		<div class="-intro-x breadcrumb mr-auto hidden sm:flex"></div>

		<div class="intro-x relative mr-3 sm:mr-6"></div>

		<div class="intro-x dropdown mr-auto sm:mr-6"></div>

		<div class="intro-x dropdown mr-auto sm:mr-6">
			<div
				class="
					dropdown-toggle
					notification notification--bullet
					cursor-pointer
				"
				role="button"
				aria-expanded="false"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24px"
					height="24px"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
					class="
						feather feather-bell
						notification__icon
						dark:text-gray-300
						notification__icon
						dark:text-gray-300
					"
				>
					<path
						d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
					></path>
					<path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
				</svg>
			</div>
			<div class="notification-content pt-2 dropdown-menu">
				<div
					class="
						notification-content__box
						dropdown-menu__content
						box
						dark:bg-dark-6
					"
				>
					<div class="notification-content__title">Notifications</div>
					<div class="cursor-pointer relative flex items-center">
						<div class="w-12 h-12 flex-none image-fit mr-1">
							<img
								alt="Icewall Tailwind HTML Admin Template"
								class="rounded-full"
								src="data:image/jpeg;base64,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"
							/>
							<div
								class="
									w-3
									h-3
									bg-theme-9
									absolute
									right-0
									bottom-0
									rounded-full
									border-2 border-white
								"
							></div>
						</div>
						<div class="ml-2 overflow-hidden">
							<div class="flex items-center">
								<a
									href="javascript:;"
									class="font-medium truncate mr-5"
									>Brad Pitt</a
								>
								<div
									class="
										text-xs text-gray-500
										ml-auto
										whitespace-nowrap
									"
								>
									05:09 AM
								</div>
							</div>
							<div class="w-full truncate text-gray-600 mt-0.5">
								Contrary to popular belief, Lorem Ipsum is not
								simply random text. It has roots in a piece of
								classical Latin literature from 45 BC, making it
								over 20
							</div>
						</div>
					</div>
					<div class="cursor-pointer relative flex items-center mt-5">
						<div class="w-12 h-12 flex-none image-fit mr-1">
							<img
								alt="Icewall Tailwind HTML Admin Template"
								class="rounded-full"
								src="data:image/jpeg;base64,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"
							/>
							<div
								class="
									w-3
									h-3
									bg-theme-9
									absolute
									right-0
									bottom-0
									rounded-full
									border-2 border-white
								"
							></div>
						</div>
						<div class="ml-2 overflow-hidden">
							<div class="flex items-center">
								<a
									href="javascript:;"
									class="font-medium truncate mr-5"
									>Brad Pitt</a
								>
								<div
									class="
										text-xs text-gray-500
										ml-auto
										whitespace-nowrap
									"
								>
									04:50 AM
								</div>
							</div>
							<div class="w-full truncate text-gray-600 mt-0.5">
								Contrary to popular belief, Lorem Ipsum is not
								simply random text. It has roots in a piece of
								classical Latin literature from 45 BC, making it
								over 20
							</div>
						</div>
					</div>
					<div class="cursor-pointer relative flex items-center mt-5">
						<div class="w-12 h-12 flex-none image-fit mr-1">
							<img
								alt="Icewall Tailwind HTML Admin Template"
								class="rounded-full"
								src="data:image/jpeg;base64,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"
							/>
							<div
								class="
									w-3
									h-3
									bg-theme-9
									absolute
									right-0
									bottom-0
									rounded-full
									border-2 border-white
								"
							></div>
						</div>
						<div class="ml-2 overflow-hidden">
							<div class="flex items-center">
								<a
									href="javascript:;"
									class="font-medium truncate mr-5"
									>Al Pacino</a
								>
								<div
									class="
										text-xs text-gray-500
										ml-auto
										whitespace-nowrap
									"
								>
									07:00 PM
								</div>
							</div>
							<div class="w-full truncate text-gray-600 mt-0.5">
								It is a long established fact that a reader will
								be distracted by the readable content of a page
								when looking at its layout. The point of using
								Lorem
							</div>
						</div>
					</div>
					<div class="cursor-pointer relative flex items-center mt-5">
						<div class="w-12 h-12 flex-none image-fit mr-1">
							<img
								alt="Icewall Tailwind HTML Admin Template"
								class="rounded-full"
								src="data:image/jpeg;base64,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"
							/>
							<div
								class="
									w-3
									h-3
									bg-theme-9
									absolute
									right-0
									bottom-0
									rounded-full
									border-2 border-white
								"
							></div>
						</div>
						<div class="ml-2 overflow-hidden">
							<div class="flex items-center">
								<a
									href="javascript:;"
									class="font-medium truncate mr-5"
									>Russell Crowe</a
								>
								<div
									class="
										text-xs text-gray-500
										ml-auto
										whitespace-nowrap
									"
								>
									05:09 AM
								</div>
							</div>
							<div class="w-full truncate text-gray-600 mt-0.5">
								There are many variations of passages of Lorem
								Ipsum available, but the majority have suffered
								alteration in some form, by injected humour, or
								randomi
							</div>
						</div>
					</div>
					<div class="cursor-pointer relative flex items-center mt-5">
						<div class="w-12 h-12 flex-none image-fit mr-1">
							<img
								alt="Icewall Tailwind HTML Admin Template"
								class="rounded-full"
								src="data:image/jpeg;base64,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"
							/>
							<div
								class="
									w-3
									h-3
									bg-theme-9
									absolute
									right-0
									bottom-0
									rounded-full
									border-2 border-white
								"
							></div>
						</div>
						<div class="ml-2 overflow-hidden">
							<div class="flex items-center">
								<a
									href="javascript:;"
									class="font-medium truncate mr-5"
									>Richard Gere</a
								>
								<div
									class="
										text-xs text-gray-500
										ml-auto
										whitespace-nowrap
									"
								>
									06:05 AM
								</div>
							</div>
							<div class="w-full truncate text-gray-600 mt-0.5">
								Contrary to popular belief, Lorem Ipsum is not
								simply random text. It has roots in a piece of
								classical Latin literature from 45 BC, making it
								over 20
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BEGIN: Account Menu -->
		<AccountMenu/>
		<!-- END: Account Menu -->
	</TopBar>
</template>

<script>
import {
	TopBar
} from '@success-apps/sa-vue-tailwind';
import AccountMenu from './AccountMenu.vue';

export default {
	components: {
		TopBar,
		AccountMenu
	}
};
</script>
